import React, { useState } from 'react';
import axios from 'axios';
import { Row, Column, TextInput, Button, Alert } from '@pella/sash-framework';
import { validateEmail, validatePostal } from '../../utilities/functions';

const EmailSignup = () => {
	const [values, setValues] = useState({ leadSource: 'Footer', email: '', postal: '' });
	const [error, setError] = useState(null);
	const [success, setSuccess] = useState(false);

	const onInputChange = (e) => setValues({ ...values, [e.target.name]: e.target.value });

	const onFormSubmit = (e) => {
		e.preventDefault();

		setSuccess(false);
		setError(null);

		var isValid = validateEmail(values.email),
			isZipValid = validatePostal(values.postal);

		const data = new FormData(e.currentTarget);

		if (isValid && isZipValid) {
			// Submit to Eloqua
			axios
				.post('https://s1920192983.t.eloqua.com/e/f2', data)
				.then((res) => {
					if (res.status === 200) {
						setSuccess(true);
					}
				})
				.catch(() => {});
		} else if (isValid) {
			setError('Please enter a valid postal code.');
		} else if (isZipValid) {
			setError('Please enter a valid email address.');
		} else {
			setError('Please enter a valid email address and postal code.');
		}
	};

	return (
		<div className='pal-emailSignup'>
			{success && (
				<Alert
					type='success'
					hideClose
				>
					Thank you for submitting!
				</Alert>
			)}

			<form
				id='PellaEmailNurture'
				name='PellaEmailNurture'
				onSubmit={onFormSubmit}
				className='pal-emailSignup-Form mx-auto max-w-xl text-left'
			>
				<input
					type='hidden'
					name='elqFormName'
					value='PellaEmailNurture'
				/>
				<input
					type='hidden'
					name='elqSiteID'
					value='1920192983'
				/>
				<input
					type='hidden'
					name='elqCustomerGUID'
					value=''
				/>
				<input
					type='hidden'
					name='elqCookieWrite'
					value='0'
				/>
				<input
					type='hidden'
					name='leadsource'
					value={values.leadSource}
				/>

				<Row align='end'>
					<Column
						xs={12}
						lg='fluid'
					>
						<TextInput
							type='email'
							id='email'
							labelText='Email'
							className='pal-emailSignup-Input'
							groupClass='lg:mb-0'
							onChange={onInputChange}
							value={values.email}
							autoComplete='email'
						/>
					</Column>

					<Column
						xs={12}
						lg='fluid'
					>
						<TextInput
							id='postal'
							labelText='Zip Code'
							className='pal-emailSignup-Input'
							groupClass='lg:mb-0'
							onChange={onInputChange}
							value={values.zip}
							autoComplete='postal-code'
						/>
					</Column>

					<Column
						xs={12}
						lg='auto'
					>
						<Button
							type='submit'
							color='primary-alt'
							data-gtm-linktype='button'
							data-gtm-linktext='Email Sign Up'
							className='!w-full lg:h-[54px] lg:py-1'
						>
							Submit
						</Button>
					</Column>

					<Column xs={12}>
						{error && (
							<Alert
								type='error'
								hideClose={true}
								className='pal-emailSignup-Error mt-2.5 py-1 text-sm'
							>
								{error}
							</Alert>
						)}
					</Column>
				</Row>
			</form>
		</div>
	);
};

export default EmailSignup;
